import { memo } from "react";

function OilCond() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.61046 3.64978C7.61046 3.64978 15.2209 12.4629 15.2209 16.6923C15.2208 20.9215 11.8135 24.35 7.61046 24.3502C3.40729 24.3502 8.31758e-05 20.9217 0 16.6923C0 12.4629 7.61046 3.64978 7.61046 3.64978Z"
        fill="currentColor"
      />
      <path
        d="M22.1072 9.50147C22.1072 9.50147 24.5621 12.3443 24.5621 13.7086C24.5621 15.0728 23.463 16.1787 22.1072 16.1787C20.7514 16.1787 19.6524 15.0728 19.6523 13.7086C19.6523 12.3443 22.1072 9.50147 22.1072 9.50147Z"
        fill="currentColor"
      />
      <path
        d="M18.8321 16.6358C18.8321 16.6358 21.287 19.4787 21.287 20.8429C21.287 22.2071 20.1879 23.3131 18.8321 23.3131C17.4763 23.3131 16.3772 22.2072 16.3772 20.8429C16.3772 19.4787 18.8321 16.6358 18.8321 16.6358Z"
        fill="currentColor"
      />
      <path
        d="M25.5451 16.6406C25.5451 16.6406 28 19.4834 28 20.8477C28 22.2119 26.9009 23.3178 25.5451 23.3179C24.1893 23.3179 23.0903 22.2119 23.0902 20.8477C23.0902 19.4834 25.5451 16.6406 25.5451 16.6406Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(OilCond);
